import React, { FC, useCallback, useMemo } from 'react';
import styled from 'styled-components/native';

import { EDataTestId } from '@webtrader/core/constants/test';
import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';
import { useCompany } from '@webtrader/core/services/company';
import { checkIsNative } from '@webtrader/core/validators/device';

import Text from '@/components/Text';
import { openInAppBrowser } from '@/utils/web';

const DemoCreationTermsAndConditions: FC = () => {
  const { t } = useTranslation();
  const { company } = useCompany();
  const { webtraderMemberTncUrl, webtraderMemberPolicyUrl } = company || {};

  const openTncUrl = useCallback(() => {
    openInAppBrowser(webtraderMemberTncUrl);
  }, [webtraderMemberTncUrl]);

  const openPolicyUrl = useCallback(() => {
    openInAppBrowser(webtraderMemberPolicyUrl);
  }, [webtraderMemberPolicyUrl]);

  const tncUrl = useMemo(() => {
    return (
      <StyledTncText isLink={true} onPress={() => openTncUrl()} testID={EDataTestId.DEMO_ACCOUNT_CREATION_TNC}>
        {t('Terms and Conditions')}
      </StyledTncText>
    );
  }, [openTncUrl, t]);

  const ppUrl = useMemo(() => {
    return (
      <StyledTncText isLink={true} onPress={() => openPolicyUrl()} testID={EDataTestId.DEMO_ACCOUNT_CREATION_DPP}>
        {t('Data Privacy Policy')}
      </StyledTncText>
    );
  }, [openPolicyUrl, t]);

  return (
    <StyledFormTncContainer>
      <StyledTncText>
        {t('By selecting "Agree and continue" below, I agree to the')} {tncUrl} {t('and')} {ppUrl}{' '}
        {t('for opening a demo account.')}
      </StyledTncText>
    </StyledFormTncContainer>
  );
};

export default DemoCreationTermsAndConditions;

const StyledFormTncContainer = styled.View`
  display: flex;
  padding: ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;
  margin: ${dynamicSize.convertSize(6)}px 0;
  background-color: ${({ theme }) => theme.colors.background[0]};
`;

const StyledTncText = styled(Text)<{ isLink?: boolean }>`
  text-align: ${() => (checkIsNative() ? 'left' : 'start')};

  font-size: ${dynamicSize.convertSize(14)}px;
  text-decoration: ${({ isLink }) => (isLink ? 'underline' : 'none')};
  text-decoration-color: ${({ theme, isLink }) => (isLink ? theme.colors.primary : theme.colors.text[0])};
  color: ${({ theme, isLink }) => (isLink ? theme.colors.primary : theme.colors.text[0])};
`;
